import React, {FC} from "react";

interface BPProps {
    styles: any
}
const PaymentsList:FC <BPProps> = ({styles}) => {
    const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
    return (
        <div
            className='m-2 p-2'
            style={{
                border: `1px solid ${styles.colors.fontColor}`,
                borderRadius: '10px',
                color: styles.colors.fontTitleColor,
                fontSize: styles.fonts.titleFontSize,
                backgroundColor: styles.colors.blockTitleBgColor,
                textTransform: 'uppercase',
                position: 'relative',
            }}
        >
            <h3
                style={{
                    display: "flex",
                    alignItems: "center",
                    position: "absolute",
                    fontSize: '10px',
                    top: -12,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: styles.colors.blockTitleBgColor,
                    color: styles.colors.fontTitleColor,
                    padding: '5px',
                    borderRadius: '5px',
                }}

            >
                <div>Secured by</div>
                <img className='paystack-logo'
                     src={toAbsoluteUrl('/assets/img/paystack/paystack_logo_text.webp')}
                     alt="paystack"
                     style={{height: '15px', width: 'auto', marginLeft: '5px'}}
                />
            </h3>
            <ul
                style={{
                    listStyle: 'none',
                    padding: '0',
                    paddingTop: '15px',
                    margin: '0',
                    display: 'flex',
                    alignItems: 'baseline',
                    justifyContent: 'space-between',
                }}
                className='payments-ul'
            >
                <li>
                    <img className='paystack-logo'
                         src={toAbsoluteUrl('/assets/img/paystack/paystack_logo_icon.webp')}
                         alt="paystack"
                         style={{height: 'auto', width: '60%', margin: '0 auto'}}
                    />
                </li>
                <li>
                    <img className='paystack-logo'
                         src={toAbsoluteUrl('/assets/img/paystack/visa_logo.webp')}
                         alt="paystack"
                         style={{height: 'auto', width: '100%',}}
                    />
                </li>
                <li>
                    <img className='paystack-logo'
                         src={toAbsoluteUrl('/assets/img/paystack/mastercard_logo.webp')}
                         alt="paystack"
                         style={{height: 'auto', width: '80%',}}
                    />
                </li>
                <li>
                    <img className='paystack-logo'
                         src={toAbsoluteUrl('/assets/img/paystack/verve_logo.webp')}
                         alt="paystack"
                         style={{height: 'auto', width: '100%',}}
                    />
                </li>
                <li>
                    <img className='paystack-logo'
                         src={toAbsoluteUrl('/assets/img/paystack/opay.webp')}
                         alt="paystack"
                         style={{height: 'auto', width: '100%',}}
                    />
                </li>
                <li>
                    <img className='paystack-logo'
                         src={toAbsoluteUrl('/assets/img/paystack/ZAP_logo.webp')}
                         alt="paystack"
                         style={{height: 'auto', width: '70%',}}
                    />
                </li>
            </ul>
        </div>
    )
};

export default PaymentsList;